import { type Guard, Info } from '@capsicum/common';
import { GenericDrawer, ModalService, useRouter } from '@capsicum/common-web';
import { useWCPledgeDisclaimer } from '@capsicum/features/world-championship-pledge/shared';
import { useCallback, useMemo } from 'react';

export const useWCPledgeDisclaimerGuard: Guard = () => {
	const router = useRouter();
	const { intlTexts, onAccepted, status } = useWCPledgeDisclaimer();
	const isInTutorialScreen = router.pathname === '/locker-room-internationals/tutorial';

	const extendedStatus = useMemo(() => (isInTutorialScreen ? 'allowed' : status), [isInTutorialScreen, status]);

	const onDenied = useCallback(() => {
		ModalService.addModal({
			detached: true,
			onDismiss: () => {
				ModalService.clearModals();
				router.push('/');
			},
			renderComponent: ({ close }) => (
				<GenericDrawer
					buttonText={intlTexts.buttonText}
					description={intlTexts.description}
					image={Info}
					testID="wc-pledge-disclaimer-drawer"
					title={intlTexts.title}
					onButtonPress={() => onAccepted(close)}
				/>
			)
		});
	}, [intlTexts, onAccepted, router]);

	return {
		onDenied,
		status: extendedStatus
	};
};
